<template>
  <div class="chart-container">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Doughnut, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: "right",
          align: "center",
          labels: {
            padding: 20,
            boxWidth: 12,
            fontSize: 11,
            usePointStyle: true,
          },
        },
        cutoutPercentage: 75,
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              const dataset = data.datasets[tooltipItem.datasetIndex];
              const total = dataset.data.reduce(
                (previousValue, currentValue) => previousValue + currentValue,
                0
              );
              const currentValue = dataset.data[tooltipItem.index];
              const percentage =
                total > 0 ? Math.round((currentValue / total) * 100) : 0;

              return `${
                data.labels[tooltipItem.index]
              }: ${new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(currentValue)} (${percentage}%)`;
            },
          },
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        elements: {
          arc: {
            borderWidth: 1,
            borderColor: "#fff",
          },
        },
      }),
    },
  },
  mounted() {
    // Check if we have data before rendering
    if (
      this.chartData &&
      this.chartData.datasets &&
      this.chartData.datasets.length > 0 &&
      this.chartData.datasets[0] &&
      this.chartData.datasets[0].data &&
      this.chartData.datasets[0].data.length > 0
    ) {
      this.renderChart(this.chartData, this.options);
    } else {
      // Render empty state or placeholder
      this.renderChart(
        {
          labels: ["No Data"],
          datasets: [
            {
              data: [1],
              backgroundColor: ["#f0f0f0"],
              borderWidth: 0,
            },
          ],
        },
        {
          ...this.options,
          legend: {
            display: false,
          },
          tooltips: {
            enabled: false,
          },
        }
      );
    }
  },
};
</script>

<style scoped>
.chart-container {
  position: relative;
  height: 300px;
  width: 100%;
}
</style>
